/**
 * LocationCheckbox Component
 */

import { linkWithCurrentQueryString } from '../../../../../utils/router';
import { baseline } from '../../../../styles/grid';

import * as React from 'react';

import Button from '../../../../atoms/buttons/Button';
import { IconInfoFilled } from '../../../../atoms/images/Icon';
import { Span } from '../../../../atoms/text/Label';
import { Tooltip } from '../../../../atoms/text/Tooltip';
import { componentHints, IComponentHint } from '../../../../organisms/forms/LicenseBuilder/config';
import { FAQPagePath } from '../../../../pages/FAQ';
import CheckboxWithLabel from '../../CheckboxWithLabel';

interface ILocationCheckboxProps {
  checked: boolean;
  id: LicenseBroadcastTerritoryTypeIdentifier | LicenseProducerLocationTypeIdentifier;
  name: string;
  onChange(component: ILicenseComponent, checked: boolean): void;
}

type ILocationTooltipProps = Pick<IComponentHint, 'hint'>;

const LocationTooltip: React.SFC<ILocationTooltipProps> = ({ hint }) => (
  <Tooltip
    content={(
      <div>
        <Span
          size="medium"
          block
        >{hint}
        </Span>
        <Button
          label="See FAQ for details"
          variant="hyperlink"
          wrapperComponent="a"
          hyperLinkProps={{
            href: linkWithCurrentQueryString(`${FAQPagePath}/licensing-music#license-territories-and-clusters`),
            target: '_blank',
          }}
          style={{
            marginTop: baseline,
          }}
        />
      </div>
    )}
    distance={baseline * 1.5}
    placement="bottom"
    theme="black"
    interactive
  >
    <IconInfoFilled className="tooltip" />
  </Tooltip>
);

export class LocationCheckbox extends React.PureComponent<ILocationCheckboxProps> {
  componentHint: IComponentHint | undefined;

  constructor(props: ILocationCheckboxProps) {
    super(props);
    this.componentHint = componentHints.find((comp) => comp.id === props.id);
  }

  onChange = (checked: boolean) => {
    const {
      id,
      name,
      onChange,
    } = this.props;

    onChange({ id, name }, checked);
  }

  render() {
    const {
      checked,
      id,
      name,
    } = this.props;

    return (
      <CheckboxWithLabel
        checked={checked}
        onChange={this.onChange}
        label={name}
        name={`location[${id}]`}
      >
        {!!this.componentHint && <LocationTooltip hint={this.componentHint.hint} />}
      </CheckboxWithLabel>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/forms/license-builder/SelectLocation/LocationCheckbox.tsx